import type { FandomPerformanceMarkTrackData } from "common-types";
import { send } from "./sender";
import { getPrometheusAlias } from "../utils/alias";

export function sendPerformanceMark({
  event,
  payload,
  alias,
}: FandomPerformanceMarkTrackData) {
  const name = alias ?? event;
  const suffix = payload.slotName ? `_${payload.slotName}` : "";

  send("time", {
    action: `${name}${suffix}`,
    duration: Math.round(payload.time),
  });
}

/**
 * PerformanceMeasure is a duration between two marks. This method transforms a measure
 * and sends it to the relevant tracking endpoint
 */
export function sendPerformanceDuration(entry: PerformanceMeasure) {
  const name = getPrometheusAlias(entry.name);

  const durationEvent = {
    action: name,
    duration: Math.round(entry.duration),
  };

  send("time", durationEvent);
}
